import { get, post } from 'libs/api';

import { apiAuthGroup } from '../../../api/apiAuthGroup';
import { apiAuthUi } from '../../../api/apiAuthUi';

import { WLProductT } from './model';

type Params = {
  payload: {
    domain: string;
  };
  success: WLProductT & { email: string };
  error: never;
};

export type GroupSMSSettingsRequestPayload = {
  uuid: string;
  smsNumber: string;
  sid: string;
  authToken?: string;
};

type CustomMethods = {
  updateSmsParameters: {
    payload: GroupSMSSettingsRequestPayload;
    success: true;
    error: never;
  };
};

// Read by the sign-in screens before anyone is signed in, so it is an application route, not a /v1 one.
// The operation names the contract entry the response is decoded with until the generated codecs are retired.
export const getProductDetails = apiAuthUi.makeApi<Params>({ ...get('/products'), operation: 'GET /auth/v1/products' });

export const wlProductGroupApi = apiAuthGroup.namespace<WLProductT, CustomMethods>('wlproduct', {
  resource: 'white_label_products',
  routes: { updateSmsParameters: post('/white_label_products/{uuid}') },
});
